import {
  infantKey,
  infantTagId,
  PregnancyPlanningKey,
  pregnancyPlanningTagId,
  pregnantKey,
  pregnantTagId,
  stageInfant,
  stagePregnancy,
  stagePregnancyPlanning,
  stageToddler,
  toddlerKey,
  toddlerTagId,
} from '../../Constants/GeneralItemsKeys';
import { images } from '../../Constants/ImageUrls';
import {
  infantMetaDescription,
  infantMetaTitle,
  pregnantMetaDescription,
  pregnantMetaTitle,
  toddlerMetaDescription,
  toddlerMetaTitle,
  ttcMetaDescription,
  ttcMetaTitle,
} from '../../Constants/MetaTitleAndDescription';
import {
  getScreenName,
  keysToRemove,
  removeDefaultParams,
} from '../../Utils/helper';

import { fireEvent } from '../../Utils/fireEvent';

export const hardCodedDataParentingGrid = [
  {
    desktopUrl: images.Artboard___3,
    mobileUrl: images.artboard4,
    name: 'Pregnant',
    term_id: 1919,
  },
  {
    desktopUrl: images.Artboard___7,
    mobileUrl: images.artboard8,
    name: 'Toddler',
    term_id: 1926,
  },
  {
    desktopUrl: images.Artboard___1,
    mobileUrl: images.artboard2,
    name: 'Planning Pregnancy',
    term_id: 1929,
  },
  {
    desktopUrl: images.Artboard___5,
    mobileUrl: images.Artboard___6,
    name: 'Infant',
    term_id: 1931,
  },
];

export const getSearchParams = (obj) => {
  let params = new URLSearchParams(window?.location?.search);
  if (obj) {
    for (let key in obj) {
      params.delete(key);
      params.append(key, obj[key]);
    }
  }
  keysToRemove.forEach((elm) => {
    params.delete(elm);
  });
  if (window?.location?.search || params.toString()?.length > 0) {
    return '?' + params.toString();
  } else {
    return '';
  }
};
export const getCustomQuery = (custom_query) => {
  custom_query = removeDefaultParams(custom_query);
  const params = Object.keys(custom_query)
    .map((key) => key + '=' + custom_query[key])
    .join('&');
  if (params) {
    return '?' + params;
  } else {
    return '';
  }
};

export const getOvulationTrackerResults = (
  start,
  end,
  due,
  periodDate,
  next,
  test,
) => {
  const month = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  start =
    start.getDate() +
    ' ' +
    month[start.getMonth()] +
    ', ' +
    start.getFullYear();
  end = end.getDate() + ' ' + month[end.getMonth()] + ', ' + end.getFullYear();
  due = due.getDate() + ' ' + month[due.getMonth()] + ', ' + due.getFullYear();
  periodDate =
    periodDate.getDate() +
    ' ' +
    month[periodDate.getMonth()] +
    ', ' +
    periodDate.getFullYear();

  next =
    next.getDate() + ' ' + month[next.getMonth()] + ', ' + next.getFullYear();

  test =
    test.getDate() + ' ' + month[test.getMonth()] + ', ' + test.getFullYear();

  return { start, end, due, periodDate, next, test };
};

export const calculateOvulation = (date, count) => {
  date = new Date(date);
  let nextDate = new Date(date.getTime());
  nextDate.setDate(date.getDate() + count);

  let nextTest = new Date(date.getTime());
  nextTest.setDate(date.getDate() + count + 1);

  let periodDate = new Date(date.getTime());
  let dueDate = new Date(date.getTime());

  date.setDate(date.getDate() + parseInt(count));

  date.setDate(date.getDate() - 14);

  let startDate = new Date(date.getTime());
  startDate.setDate(startDate.getDate() - 5);

  dueDate.setDate(dueDate.getDate() - 92);
  dueDate.setFullYear(dueDate.getFullYear() + 1);
  dueDate.setDate(dueDate.getDate() + 7);

  return {
    start: startDate,
    end: date,
    due: dueDate,
    periodDate: periodDate,
    next: nextDate,
    test: nextTest,
  };
};
export const getKeyAndIdForStage = (type) => {
  let key = null;
  let id = null;
  let stage = null;
  let metaTitle = null;
  let metaDescription = null;
  switch (type) {
    case 'pregnancy-planning':
      key = PregnancyPlanningKey;
      id = pregnancyPlanningTagId;
      stage = stagePregnancyPlanning;
      metaTitle = ttcMetaTitle;
      metaDescription = ttcMetaDescription;
      break;
    case 'pregnancy':
      key = pregnantKey;
      id = pregnantTagId;
      stage = stagePregnancy;
      metaTitle = pregnantMetaTitle;
      metaDescription = pregnantMetaDescription;
      break;
    case 'toddler':
      key = toddlerKey;
      id = toddlerTagId;
      stage = stageToddler;
      metaTitle = toddlerMetaTitle;
      metaDescription = toddlerMetaDescription;
      break;
    case 'infant':
      key = infantKey;
      id = infantTagId;
      stage = stageInfant;
      metaTitle = infantMetaTitle;
      metaDescription = infantMetaDescription;
      break;
    default:
      key = PregnancyPlanningKey;
      id = pregnancyPlanningTagId;
      stage = stagePregnancyPlanning;
      metaTitle = ttcMetaTitle;
      metaDescription = ttcMetaDescription;
      break;
  }
  return { key, id, stage, metaTitle, metaDescription };
};

export const bannerData = {
  hi: {
    heading: 'हिंदी',
    htmlText:
      'माँ बनने की तैयारी से लेकर शिशु की देखभाल तक सभी जानकारी हिंदी भाषा में पाएं।',
    desktopImage: images.hi_bangla_dweb1,
    mobileWebImage: images.hi_bangla_mweb1,
  },

  bn: {
    heading: 'বাংলা',
    htmlText:
      'মা হওয়ার প্রস্তুতি থেকে শিশুর দেখাশোনা পর্যন্ত সব তথ্য বাংলায় পেয়ে যান।',
    desktopImage: images.hi_bangla_dweb2,
    mobileWebImage: images.hi_bangla_mweb2,
  },
  // Tamil
  ta: {
    heading: 'தமிழ்',
    htmlText:
      'ஒரு தாயாக ஆக தயாராகுவதில் இருந்து குழந்தையைப் பெற்று நன்கு பராமரிக்கும் வரை தேவையான அனைத்துத் தகவல்களையும் தமிழில் பெறுங்கள்.',
    desktopImage: images.hi_bangla_dweb2,
    mobileWebImage: images.hi_bangla_mweb2,
  },
  // Telugu
  te: {
    heading: 'తెలుగు',
    htmlText:
      'తల్లి అవడం నుండి బిడ్డను సంరక్షించడం వరకు మొత్తం సమాచారాన్ని హిందీలో పొందండి. అన్ని ఆర్టికల్స్ మరియు వీడియోలు.',
    desktopImage: images.hi_bangla_dweb2,
    mobileWebImage: images.hi_bangla_mweb2,
  },
};
export const testimonials = {
  heading: 'Why Buyers Love Us',
  itemName: 'Web Testimonials',
  items: [
    {
      desktopImage: images.desktopImage_164454941925,
    },
    {
      desktopImage: images.desktopImage_164454939968,
    },
    {
      desktopImage: images.desktopImage_164454938433,
    },
  ],
};
export const languageRedirectionLinks = [
  {
    lang: 'english',
    link: '/parenting',
  },
  {
    lang: 'हिन्दी',
    link: '/hi/parenting',
  },
  {
    lang: 'বাঙ্গালী',
    link: '/bn/parenting',
  },
];

export const fireExpandEvent = () => {
  fireEvent({
    category: 'expanded_sidedrawer_item',
    screen_name: getScreenName(),
    parent: 'language',
  });
};
export const clickedExpandItem = (lang, url) => {
  fireEvent({
    category: 'clicked_sidedrawer_item',
    screen_name: getScreenName(),
    parent: 'language',
    item_name: lang,
    deeplink_value: url,
    page_url: window.location.href.slice(0, 98),
  });
};
export const getTitle = (lang) => {
  switch (lang) {
    case 'hi':
      return 'सभी लेख और वीडियो';
    case 'bn':
      return 'সব লেখা ও ভিডিও';
    case 'ta':
      return 'அனைத்து கட்டுரைகள் மற்றும் வீடியோக்கள்';
    case 'te':
      return 'అన్ని కథనాలు మరియు వీడియోలు';
  }
};
